import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DialogService, PopupButton, PopupOpenEventArgs } from '../app.dialog-service';
import { TranslationService } from '../app.translation-service';

@Component({
	selector: 'app-popup',
	templateUrl: './popup.component.html',
	styleUrls: ['./popup.component.less']
})
export class PopupComponent {

	/**
	 * Args
	 */
	@Input()
	public args?: PopupOpenEventArgs | null;

	/**
	 * Constructor
	 */
	constructor(public dialogService: DialogService, public i18n: TranslationService) {
	}

	/**
	 * Close popup
	 */
	public closePopup(): void {
		this.dialogService.closePopup();
	}

	/**
	 * Click button
	 */
	 public clickButton(button: PopupButton): void {
		if (button.action) {
			if (button.action() === true) {
				this.closePopup();
			}
		} else {
			this.closePopup();
		}
	}
}
